import React from 'react';
import { useSelector } from 'react-redux';
import { Row, Col, FormGroup, Label, Input, Button, Card, CardBody, FormText, Spinner } from 'reactstrap';
import { ApplicationState } from 'store';
import Select, { components } from "react-select";

export interface DripStep { templateId: string; delay_days: number; template: any;}
interface Props {
    enabled: boolean;
    steps: DripStep[];
    onToggle: (v: boolean) => void;
    onChange: (steps: DripStep[]) => void;
    templates: { value: string; label: string }[];
}
export default function StepDripSettings({ enabled, steps, onToggle, onChange, templates }: Props) {
    const loadingTemplates = useSelector((s: ApplicationState) => s.templates.dataLoading);
    const add = () => onChange([...steps, { templateId: '', delay_days: 1, template: null}]);
    const upd = (i: number, v: Partial<DripStep>) => {
        const a = [...steps]; a[i] = { ...a[i], ...v }; onChange(a);
    };
    const rm = (i: number) => onChange(steps.filter((_, j) => j !== i));

        
    // Template Option Renderer
    const TemplateOption = (props: any) => {
        const { data } = props;
        return (
            <components.Option {...props}>
                <div>
                    <div className="fw-semibold">{data.label}</div>
                    <div className="small">{data.id}</div>
                </div>
            </components.Option>
        );
    };
    const TemplateSingleValue = (props: any) => {
        const { data } = props;
        return (
            <components.SingleValue {...props}>
                <span className="fw-semibold">{data.label}</span>
                <span className="text-muted small ms-2">{data.id}</span>
            </components.SingleValue>
        );
    };

    return (<>
            <Row>
                <Col>
                    <div className="d-flex gap-2 align-items-center">
                        <Label className="fw-semibold fs-5 mb-0 d-flex align-items-center">
                            <i className={`ri-flow-chart me-2`} />
                            Enable Drip Sequence
                        </Label>
                        <div className="form-check form-switch">
                            <Input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                checked={enabled}
                                onChange={e => onToggle(e.target.checked)} 
                            />
                        </div>
                    </div>
                </Col>
            </Row>
            {enabled && <Card className="mt-3"><CardBody>
                {steps?.length ? steps?.map((item: any, index: any) => {
                    return <Row className="d-flex justify-content-start px-2 gap-1">
                            
                            <Col md={3} className='d-flex p-0'>
                                <FormGroup className='w-100'>
                                    <Label className="fw-semibold mb-1">#{index + 1} Delay Days</Label>
                                    <Input
                                        type="number"
                                        placeholder="Enter number of days"
                                        min={1}
                                        style={{ minWidth: 150, minHeight: 39 }}
                                        value={item?.delay_days || ''}
                                        onChange={(e: any) => upd(index, { delay_days: +e.target.value })}
                                    />
                                    {index > 0 ? <FormText color="muted">
                                        Please enter the delay (in days) from the previous step.
                                    </FormText> : null}
                                </FormGroup>
                            </Col>
                            <Col md={5} className='p-0'>
                                <FormGroup>
                                    <Label className="fw-semibold mb-1">Template</Label>
                                    {loadingTemplates ? (
                                        <Spinner size="sm" />
                                    ) : (
                                        <div className="mb-1">
                                            <Select
                                                options={templates}
                                                onChange={(option: any) => upd(index, { templateId: option?.value, template: option?.template })}
                                                value={templates.find(o => o.value === item?.templateId) || null}
                                                placeholder="Select a template..."
                                                isClearable
                                                noOptionsMessage={() => "No templates found for this account"}
                                                components={{ Option: TemplateOption, SingleValue: TemplateSingleValue }}
                                            />
                                        </div>
                                    )}
                                    <FormText color="muted">
                                        Pick an approved template for this channel.
                                    </FormText>
                                </FormGroup>
                            </Col>
                            <Col md={1} className='d-flex align-items-center p-0'>
                                <div className="d-flex align-items-center justify-content-start" style={{ minWidth: 80, paddingBottom:20 }}>
                                    <i className="ri-delete-bin-fill fs-5 text-danger cursor-pointer"
                                        onClick={() => rm(index)}
                                    />
                                </div>
                            </Col>
                        <div>
                            {
                                index === steps?.length - 1 && steps?.length < 5 ?
                                    <button className='d-flex w-auto btn btn-primary btn-sm' onClick={() => add()}>Add Step + </button>
                                    : null
                            }
                        </div>
                    </Row>
                }) : null}
                <div>
                    {!steps?.length ?
                        <button className='d-flex w-auto  btn btn-primary btn-sm' onClick={() => add()}>Add Step + </button>
                        : null
                    }
                </div>
            </CardBody></Card>}
    </>);
}